module.exports = __webpack_public_path__ + "img/happyfox.aff79122.png";